import { cn } from '../../lib/utils';
import { Badge } from '../ui/badge';

export interface NewBadgeProps {
  /** Renders nothing when false — same "absent means nothing to show" contract as UnreadBadge. */
  show: boolean;
  className?: string;
}

/**
 * Floating "NEW" pill — the unseen-version counterpart to UnreadBadge's
 * message-count badge. Anchors to a relatively-positioned parent, top-right
 * corner; ReviewAction moves its paired UnreadBadge to top-left so both can
 * float on the same trigger without overlapping.
 */
export function NewBadge({ show, className }: NewBadgeProps) {
  if (!show) return null;

  return (
    <Badge
      role="status"
      aria-label="New"
      className={cn(
        'pointer-events-none absolute -top-1.5 -right-1.5 select-none items-center justify-center',
        'h-[16px] rounded-full border-0 px-[5px] ring-2 ring-white',
        'text-[9px] leading-none font-semibold tracking-wide text-white uppercase',
        'animate-in zoom-in-50 duration-150',
        'bg-(--brand-500)',
        className,
      )}
    >
      New
    </Badge>
  );
}
